/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../drawerManager.module.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.DrawerManager.PosStationPrompt {
    "use strict";

    export const POS_STATION_PROMPT_OPT_OUT_COOKIE = "POSStationPromptOptOut";
    export const POS_STATION_PROMPT_COOKIE_EXPIRATION_DAYS = 3650; // matches the POSStation cookie's own lifecycle
    const CONFIRMATION_DISPLAY_DURATION_MS = 1500;

    export class PosStationPromptModalController {
        static $inject = [
            "$mdDialog",
            "$cookies",
            "$timeout",
            "meevo.components.common.DataService",
            "posStations"
        ];

        public selectedStation: Meevo.Model.Device = null;
        public confirmationMessageKey: string = null;
        public isSaving: boolean = false;
        public activationFailed: boolean = false;

        constructor(
            protected $mdDialog: angular.material.IDialogService,
            protected $cookies: angular.cookies.ICookiesService,
            protected $timeout: angular.ITimeoutService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            public posStations: Meevo.Model.Device[]
        ) { }

        activate = (): void => {
            if (!this.selectedStation || this.isSaving) {
                return;
            }

            this.isSaving = true;
            this.activationFailed = false;

            this.dataService.customMethodData(
                `api/PosHardware/Device/${this.selectedStation.id}/Cookie?numDaysToExpiration=${POS_STATION_PROMPT_COOKIE_EXPIRATION_DAYS}`,
                "GET",
                ""
            ).then(() => {
                this.confirmationMessageKey = "MESSAGE_POS_STATION_ACTIVATED";
                this.$timeout(() => this.$mdDialog.hide(true), CONFIRMATION_DISPLAY_DURATION_MS);
            }).catch(() => {
                this.activationFailed = true;
            }).finally(() => {
                this.isSaving = false;
            });
        }

        optOut = (): void => {
            if (this.isSaving) {
                return;
            }

            this.isSaving = true;

            let expires = new Date();
            expires.setDate(expires.getDate() + POS_STATION_PROMPT_COOKIE_EXPIRATION_DAYS);
            this.$cookies.put(POS_STATION_PROMPT_OPT_OUT_COOKIE, "1", { expires: expires, path: "/" });
            this.confirmationMessageKey = "MESSAGE_POS_STATION_OPT_OUT_SAVED";
            this.$timeout(() => this.$mdDialog.hide(false), CONFIRMATION_DISPLAY_DURATION_MS);
        }
    }

    angular.module("meevo.plugins.drawerManager")
        .controller("meevo.plugins.drawerManager.posStationPrompt.PosStationPromptModalController", PosStationPromptModalController);
}
